import { useWorkflowOrchestration } from "@/hooks/useWorkflowOrchestration";
import { useAutomationEventDetection } from "@/hooks/useAutomationEventDetection";

/**
 * Wrapper component that runs workflow orchestration and automation event
 * detection inside the AppDataProvider + AutomationRunnerProvider context.
 */
export function WorkflowOrchestrator() {
  useWorkflowOrchestration();
  useAutomationEventDetection();
  return null;
}
